import { extractTags } from "./constructQuizResponse";

const fetchCustomRedirectionIfAny = (data, userResponse) => {
    if (data.quizTagBasedRedirection?.length > 0) {
        const userTags = extractTags(userResponse);
        // Clone and sort by specificity (longest tagList first)
        const sortedRules = data.quizTagBasedRedirection
            .slice()
            .sort((a, b) => b.tagList.length - a.tagList.length);

        for (const rule of sortedRules) {
            const allMatch = rule.tagList.every(tag => userTags.includes(tag));
            if (allMatch) {
                return rule.redirectUrl;
            }
        }
    }

    return null;
};

export default fetchCustomRedirectionIfAny;